import React from 'react';
import { selectReaderManager } from '../../../ReaderManagerEvents/ReaderManagerSlice';
import { READING_MODES } from "../../../../../constants/constants";
import { useSelector } from 'react-redux';
import UpAndDownTutor from './UpAndDownTutor';
import UpAndDownAssessment from './UpAndDownAssessment';
import useWordMetadata from '../../hooks/useFetchWordMetadata';

export default function UpAndDownWrapper(props) {

  const { contextStates } = useSelector(selectReaderManager)
  const { readingMode } = contextStates

  const assessmentMode = readingMode === READING_MODES.ASSESSMENT

  const {
    speech,
    phrase,
    isFTUE,
    currentWordIndex,
    setDisableInterventionsForPhrase,
    advanceOneWord,
    skipWord,
    isInstruction,
    hasInstructions,
    phraseMetadata,
    story,
    currentPageIndex,
    currentPhraseWordMetadata,
    transcript,
    paused,
    setWillHandlePause,
    startPhrase,
    pausePhrase,
    resumePhrase,
    doneHandlingPause,
  } = props

  // For up and down, the story is constructed with the word in the last position, everything else is the graphemic breakdown.
  const word = phrase.split(" ").slice(-1)[0]
  const { wordMetadata, loading } = useWordMetadata({word})

  if(!currentPhraseWordMetadata) {
    return null; // fetching word metadata
  }

  if (!wordMetadata || !word || loading) {
    return null; // fetching word metadata
  }

  const metadata = {
    speech,
    phrase,
    ftue: isFTUE,
    currentWordIndex,
    advanceOneWord,
    skipWord,
    isInstruction,
    hasInstructions,
    phraseMetadata,
    story,
    currentPhraseWordMetadata,
    assessmentMode,
    word,
    wordMetadata,
  }

  const tutorProps = {
    metadata,
    setDisableInterventionsForPhrase
  }

  const assessmentProps = {
    metadata,
    transcript,
    currentPageIndex,
    paused,
    setWillHandlePause,
    startPhrase,
    pausePhrase,
    resumePhrase,
    doneHandlingPause,
    setDisableInterventionsForPhrase,
  }

  if (assessmentMode) {
    return (
      <UpAndDownAssessment {...assessmentProps} />
    );
  }

  return (
    <UpAndDownTutor {...tutorProps} />
  );
}